import { ModuleInfo } from './index.d'
import useQiankun from '@/utils/useQiankun'
const { isAdmin } = useQiankun()

// 星期
export const WEEK = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

// 主题名称与副标题名称
console.log("标题", isAdmin);

export const title = isAdmin.value ? '灵动数智控制台' : '数据汇总'
export const subtitle = ['预审评估', '收益分析', '收益分布']

export const moduleInfo: ModuleInfo = [
  // 中间的几个模块
  {
    name: '任务通过率',
    icon: 'icon-chart-bar',
  },
  {
    name: '地图数据',
    icon: 'icon-tongji4',
  },
  {
    name: '产品销售渠道分析',
    icon: 'icon-align-left',
  },
  {
    name: '任务完成排行榜',
    icon: 'icon-zhibiao2',
  },
  // 底部两个模块
  {
    name: '数据统计图',
    icon: 'icon-vector',
  },
  {
    name: '工单修复以及满意度统计图',
    icon: 'icon-fenxi7',
  },
]

// 定时刷新配置
export const REFRESH_CONFIG = {
  // 刷新间隔（毫秒）默认5分钟
  REFRESH_INTERVAL: 5 * 60 * 1000,
  // 是否启用定时刷新
  ENABLE_AUTO_REFRESH: true,
  // 是否只在页面可见时刷新
  REFRESH_ONLY_WHEN_VISIBLE: true,
  // 刷新时是否显示loading（开发环境显示，生产环境隐藏）
  SHOW_REFRESH_LOADING: process.env.NODE_ENV === 'development'
}
